import { IAppState } from '../../redux';

export const selectIsNewbuildingSaleCategory = (state: IAppState): boolean => {
  return state.offer.category === 'newBuildingFlatSale';
};
